import {Backdrop, CircularProgress} from '@mui/material';

export interface SpinProps {
  spinning: boolean;
}

function Spin({spinning}: SpinProps): JSX.Element {
  return (
    <Backdrop open={spinning} sx={{zIndex: 9999}}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Spin;
